{
  "tabs": {
    "chat": "Còmhradh",
    "reminders": "Cuimhneachain",
    "calendar": "Calan",
    "settings": "Roghainnean"
  },
  "common": {
    "cancel": "Sguir dheth",
    "save": "Sàbhail",
    "confirm": "Dearbhaich",
    "delete": "Sguab às",
    "back": "Air ais",
    "close": "Dùin",
    "edit": "Deasaich",
    "search": "Rannsaich",
    "all": "Uile",
    "loading": "A’ luchdachadh...",
    "error": "Chaidh rudeigin ceàrr",
    "notFound": "Cha deach a lorg",
    "tryAgain": "Feuch a-rithist",
    "retry": "Ath-iarraidh",
    "undo": "Cuir às",
    "pullToRefresh": "Tarraing airson ùrachadh",
    "justNow": "a-nis dìreach"
  },
  "auth": {
    "welcome": "Fàilte gu FishMemory",
    "tagline": "Do neach-cuideachaidh cuimhneachaidh WhatsApp, a-nis nad phoc",
    "subtitle": "Do neach-cuideachaidh cuimhneachaidh WhatsApp, a-nis nad phoc",
    "phoneLabel": "Àireamh WhatsApp agad",
    "phoneHint": "Cuiridh sinn còd dearbhaidh tro WhatsApp",
    "invalidPhone": "Cuir a-steach àireamh fòn dligheach",
    "continue": "Lean air adhart",
    "enterPhone": "Cuir a-steach do àireamh WhatsApp",
    "phonePlaceholder": "Àireamh fòn",
    "sendCode": "Cuir Còd",
    "verifyTitle": "Dearbhaich do àireamh",
    "otpSentTo": "Chaidh còd 6-dhigit a chuir gu {{phone}} tro WhatsApp",
    "enterFullCode": "Cuir a-steach na 6 dhigit gu lèir",
    "invalidOtp": "Còd mì-dligheach. Feuch a-rithist.",
    "otpFailed": "Cha b’ urrainn còd a chuir. Feuch a-rithist.",
    "otpResent": "Còd air a chur a-rithist",
    "resendIn": "Cuir a-rithist ann an {{seconds}}s",
    "resendCode": "Cuir a-rithist còd",
    "enterOtp": "Cuir a-steach an còd a chaidh a chur gu WhatsApp agad",
    "verify": "Dearbhaich",
    "resend": "Cuir a-rithist còd",
    "wrongNumber": "Àireamh ceàrr?",
    "backToPhone": "Air ais gu fòn",
    "editPhone": "Deasaich àireamh fòn",
    "error": "Mearachd",
    "setupTitle": "Cuiramaid air dòigh",
    "setupSubtitle": "Faodaidh tu seo atharrachadh an-còmhnaidh ann an Roghainnean",
    "namePlaceholder": "D’ ainm",
    "letsGo": "Crìochnaich an rèiteachadh",
    "skipForNow": "Leum seachad an-dràsta"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Seòl teachdaireachd...",
    "inputPlaceholder": "Seòl teachdaireachd...",
    "typing": "Tha FishMemory a’ sgrìobhadh...",
    "online": "Air-loidhne",
    "connecting": "A’ ceangal...",
    "reconnecting": "A’ ceangal a-rithist...",
    "offline": "Far-loidhne",
    "empty": "Tòisich còmhradh",
    "emptyHint": "Cruthaich cuimhneachain, thoir sùil air am prògram agad, no faigh cuideachadh.",
    "emptyAction": "Cuir cuimhneachan sampall",
    "actions": "Gnìomhan còmhraidh",
    "keep": "Cùm teachdaireachdan",
    "clearTitle": "Glan còmhradh",
    "clearConfirm": "A bheil thu airson a h-uile teachdaireachd air an inneal seo a dhubhadh às? Chan urrainnear seo a chur air ais.",
    "clear": "Glan còmhradh",
    "optionSelected": "Air a thaghadh: {{label}}",
    "sendingSelection": "A’ cur...",
    "connectionLost": "A’ ceangal a-rithist..."
  },
  "reminders": {
    "title": "Mo Chuimhneachain",
    "active": "Gnìomhach",
    "today": "An-diugh",
    "thisWeek": "An t-seachdain seo",
    "history": "Eachdraidh",
    "items": "nithean",
    "emptyTitle": "Chan eil cuimhneachain ann fhathast",
    "emptySubtitle": "Cruthaich fear bhon chòmhradh agus nochdaidh e an seo.",
    "emptyAction": "Fosgail còmhradh",
    "filterActive": "Gnìomhach",
    "filterToday": "An-diugh",
    "filterWeek": "An t-seachdain seo",
    "filterHistory": "Eachdraidh",
    "emptyState": "Chan eil cuimhneachain ann fhathast. Tòisich air còmhradh!",
    "swipeDone": "Deiseil",
    "swipeSnooze": "Cuir air fois",
    "swipeDelete": "Sguab às",
    "search": "Rannsaich cuimhneachain...",
    "upcoming": "A’ tighinn",
    "completed": "Deiseil",
    "overdue": "Fadalach",
    "tomorrow": "A-màireach",
    "synced": "Sioncronach {{value}}",
    "swipeHint": "Sleamhnaich cuimhneachan airson barrachd ghnìomhan",
    "noResults": "Chan eil cuimhneachain a fhreagras ris an rannsachadh agad",
    "noResultsHint": "Feuch facal eile no glan an rannsachadh",
    "deleteAllFailed": "Cha b’ urrainn a h-uile cuimhneachan a dhubhadh às"
  },
  "calendar": {
    "title": "Calan",
    "today": "An-diugh",
    "tomorrow": "A-màireach",
    "completed": "deiseil",
    "noEvents": "Chan eil tachartasan",
    "noEventsSubtitle": "Tagh ceann-latha airson cuimhneachain is tachartasan fhaicinn.",
    "googleEvent": "Calan Google",
    "legendActive": "Gnìomhach",
    "legendRecurring": "A’ tilleadh",
    "legendDone": "Deiseil",
    "legendGoogle": "Google",
    "previousMonth": "Mìos roimhe",
    "nextMonth": "Mìos eile",
    "previousYear": "Bliadhna roimhe",
    "nextYear": "Bliadhna eile",
    "goToToday": "Rach gu an-diugh",
    "all": "Uile",
    "active": "Gnìomhach",
    "done": "Deiseil",
    "paused": "Air fois"
  },
  "settings": {
    "title": "Roghainnean",
    "profile": "Pròifil",
    "name": "Ainm taisbeanaidh",
    "enterName": "Cuir a-steach d’ ainm",
    "language": "Cànan",
    "uiLanguage": "Cànan an aplacaid",
    "uiLanguageHelp": "Bidh seo ag atharrachadh eadar-aghaidh an aplacaid, bileagan a’ chalain, agus stiùireadh an leigeil air an inneal seo a-mhàin.",
    "serverLanguage": "Cànan còmhraidh",
    "serverLanguageHelp": "Bidh seo ag atharrachadh cànan freagairtean an fhrithealaiche agus teachdaireachdan cuimhneachaidh airson do chunntas.",
    "timezone": "Sgìre-ùine",
    "currentTimezone": "Sgìre-ùine làithreach",
    "timezoneHelp": "Thèid na h-uairean cuimhneachaidh uile a shealltainn leis an sgìre-ùine seo.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sàbhail sgìre-ùine",
    "timezoneSaved": "Sgìre-ùine ùraichte",
    "detect": "Lorg",
    "detectFailed": "Cha b’ urrainn sgìre-ùine a lorg",
    "autoDetect": "Lorg fèin-ghluasadach bho GPS",
    "notifications": "Brathan",
    "notificationsHelp": "Smachd air cuimhneachain ath-thagraidh airson rabhaidhean ath-aithriseach. Tha ceadan brathan air an inneal fhathast air an riaghladh ann an Roghainnean fòn.",
    "pushEnabled": "Brathan Push",
    "autoDoneOnFire": "Comharraich gu fèin-ghluasadach nuair a thèid a losgadh",
    "autoDoneOnFireDesc": "Nuair nach eil seo air, bidh cuimhneachain gnìomhach gus am bi thu gan comharrachadh mar deiseil.",
    "googleCalendar": "Calan Google",
    "google": "Calan Google",
    "googleConnected": "Ceangailte",
    "googleDisconnected": "Gun cheangal",
    "googleConnectedHelp": "Faodar cuimhneachain ùra a shioncronadh gu fèin-ghluasadach ris a’ chalain agad.",
    "googleDisconnectedHelp": "Ceangail Calan Google gus cuimhneachain is tachartasan a chumail air leth.",
    "googleConnectFailed": "Cha b’ urrainn ceangal a dhèanamh ri Calan Google",
    "connected": "Ceangailte",
    "disconnected": "Gun cheangal",
    "connect": "Ceangail",
    "disconnect": "Cuir dheth ceangal",
    "autoSync": "Sioncronachadh fèin-ghluasadach",
    "autosync": "Sioncronachadh fèin-ghluasadach",
    "subscription": "Fo-sgrìobhadh",
    "trialUsed": "Deuchainn: {{used}}/{{total}} air a chleachdadh",
    "trialStatus": "Deuchainn ri fhaighinn",
    "activeStatus": "Fo-sgrìobhadh gnìomhach",
    "expiredStatus": "Fo-sgrìobhadh air a dhùnadh",
    "unsubscribedStatus": "Gun fo-sgrìobhadh",
    "about": "Mu dheidhinn",
    "version": "Dreach",
    "logout": "Log a-mach",
    "logoutTitle": "Log a-mach",
    "logoutConfirm": "A bheil thu cinnteach gu bheil thu airson log a-mach?",
    "noName": "Gun ainm air a shuidheachadh",
    "serverConnection": "Ceangal frithealaiche",
    "serverUrl": "URL frithealaiche",
    "serverEdit": "Deasaich",
    "saveReconnect": "Sàbhail agus ceangail a-rithist",
    "resetDefault": "Ath-shuidhich gu bunaiteach",
    "invalidServerUrlTitle": "URL frithealaiche mì-dligheach",
    "invalidServerUrlMessage": "Cuir a-steach URL frithealaiche http no https dligheach, mar eisimpleir https://example.com",
    "uiLanguageChangeFailed": "Cha b’ urrainn cànan an aplacaid atharrachadh. Feuch a-rithist.",
    "serverLanguageChangeFailed": "Cha b’ urrainn cànan còmhraidh atharrachadh. Feuch a-rithist.",
    "timezoneChangeFailed": "Cha b’ urrainn sgìre-ùine atharrachadh. Feuch a-rithist.",
    "autoSyncChangeFailed": "Cha b’ urrainn sioncronachadh fèin-ghluasadach atharrachadh. Feuch a-rithist.",
    "nameChangeFailed": "Cha b’ urrainn ainm taisbeanaidh atharrachadh. Feuch a-rithist.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Fiosrachadh cuimhneachaidh",
    "editTime": "Deasaich àm",
    "rename": "Ath-ainmeachadh",
    "snooze": "Cuir air fois",
    "snooze15": "Cuir air fois 15 mionaid",
    "pause": "Cuir air fois",
    "pauseReminder": "Cuir cuimhneachan air fois",
    "resume": "Lean air adhart",
    "resumeReminder": "Lean cuimhneachan air adhart",
    "skip": "Leum air adhart",
    "skipOccurrence": "Leum air an tachartas seo",
    "syncGoogle": "Sioncronadh gu Google",
    "delete": "Sguab às",
    "deleteTitle": "Sguab às cuimhneachan",
    "deleteConfirm": "Thèid am cuimhneachan seo a dhubhadh às gu maireannach.",
    "deleteRecurringTitle": "Sguab às cuimhneachan ath-thilleadh",
    "deleteRecurringMessage": "A bheil thu airson an tachartas seo a leum no an t-sreath gu lèir a sguabadh às?",
    "deleteThisOccurrence": "Leum an tachartas seo",
    "deleteEntireSeries": "Sguab às an t-sreath gu lèir",
    "done": "Deiseil",
    "markDone": "Comharraich mar deiseil",
    "undo": "Ath-nuadhachadh",
    "undoPrompt": "Feumaidh tu e gnìomhach a-rithist? Ath-nuadhaich e a-nis.",
    "recurring": "Ath-thilleadh",
    "nextRun": "An ath ruith",
    "oneTime": "Aon turas",
    "pending": "Ri thighinn",
    "sent": "Air a chuir",
    "paused": "Air fois",
    "active": "Gnìomhach",
    "snoozed": "Air fois",
    "localTime": "Air a shealltainn ann an àm ionadail",
    "recurrence": "Ath-thilleadh",
    "created": "Air a chruthachadh",
    "tags": "Bileagan",
    "fireCount": "Àireamhan losgaidh",
    "actions": "Gnìomhan",
    "none": "Gun",
    "snoozeFailed": "Cha b’ urrainn cuimhneachan a chur air fois",
    "pauseFailed": "Cha b’ urrainn cuimhneachan a chur air fois",
    "resumeFailed": "Cha b’ urrainn cuimhneachan a chur air adhart",
    "skipFailed": "Cha b’ urrainn cuimhneachan a leum",
    "doneFailed": "Cha b’ urrainn cuimhneachan a chomharrachadh mar deiseil",
    "undoFailed": "Cha b’ urrainn inbhe cuimhneachaidh ath-nuadhachadh",
    "deleteFailed": "Cha b’ urrainn cuimhneachan a dhubhadh às",
    "rescheduleTitle": "Ath-sgrìobhadh?",
    "rescheduleMsg": "Tha am cuimhneachan seo fadalach. Am bu toil leat ath-sgrìobhadh?",
    "reschedule15": "Ann an 15 mionaid",
    "reschedule60": "Ann an 1 uair",
    "keepOverdue": "Cùm mar a tha e"
  },
  "onboarding": {
    "slide1Title": "Fàilte gu FishMemory",
    "slide1Sub": "Do neach-cuideachaidh cuimhneachaidh pearsanta — air a chumhachdachadh le WhatsApp agus air a thogail airson do phoc.",
    "slide2Title": "Còmhradh gu nàdarra",
    "slide2Sub": "Seòl cuimhneachain mar a smaoinicheas tu: \"Cuimhnich dhomh gairm a dhèanamh air mo mhàthair a-màireach aig 3f\" — bidh sinn a’ dèanamh an còrr.",
    "slide3Title": "Na caill dad",
    "slide3Sub": "Faigh rabhaidhean ann an àm, eagraich le bileagan, agus cùm smachd air a h-uile càil a tha cudromach.",
    "getStarted": "Tòisich",
    "next": "Air adhart",
    "firstReminderTitle": "Cruthaich do chiad chuimhneachan!",
    "firstReminderHint": "Feuch ri seòl rudeigin mar:",
    "firstReminderExample": "Cuimhnich dhomh uisge òl a-màireach aig 9m",
    "gotIt": "Fhuair mi e!",
    "notifRationaleTitle": "Cùm suas ris an àm",
    "notifRationaleBody": "Feumaidh FishMemory brathan gus cuimhneachadh ort ann an àm. Gheibh thu rabhaidhean airson cuimhneachain a chruthaicheas tu a-mhàin.",
    "notifRationaleAllow": "Cuir brathan an gnìomh",
    "notifRationaleLater": "Is dòcha nas fhaide air adhart",
    "swipeHint": "Sleamhnaich deas airson gnìomhan luath →",
    "calendarDragHint": "Tarraing airson leudachadh ↕"
  }
}
